import { render } from "./ImagingAndBiopsyTests.vue?vue&type=template&id=0ffc7390&scoped=true"
const script = {}

import "./ImagingAndBiopsyTests.vue?vue&type=style&index=0&id=0ffc7390&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ffc7390"]])

export default __exports__